//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { errorReq } from '@/api/data';
export default {
  name: 'error_store_page',
  methods: {
    click: function click() {
      console.log(admin);
    },
    ajaxClick: function ajaxClick() {
      errorReq();
    }
  }
};